<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden" style="width: 95%; margin: 0 auto;">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        แบบทดสอบ
      </h1>
    </div>
  </div>
  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหาชื่อแบบทดสอบ" name="searchName"
      [(ngModel)]="search" (keyup)="searching()">
    <lifedi-btn lable="เพิ่มแบบทดสอบ" (click)="addMeasure()" customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF">
    </lifedi-btn>
  </div>

  <!-- not search -->
  <nz-table *ngIf="!isSearch" #groupingTable [nzData]="allMeasure" nzBordered nzSize="large"
    class="table table-striped">
    <thead>
      <tr>
        <th class="text-center" [nzSortFn]="sortIdFn">รหัสแบบทดสอบ</th>
        <th class="text-center">ชื่อแบบทดสอบ</th>
        <th class="text-center">วันเปิด - วันปิดแบบทดสอบ</th>
        <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
        <th class="text-center" [nzFilters]="filterViewStatus" [nzFilterFn]="viewStatusFilterFn">สถานะการมองเห็น</th>
        <th class="text-center">ลิงก์</th>
        <th class="text-center">รายละเอียด</th>
        <th class="text-center">Export</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let measure of groupingTable.data;">
        <td class="text-center">{{ measure.MEASURE_ID }}</td>
        <td class="text-center">{{ measure.MEASURE_NAME }}</td>
        <td class="text-center">
          <span *ngIf="measure.ALWAYS_OPEN === 'true'">
            เปิดตลอด
          </span>
          <span *ngIf="measure.ALWAYS_OPEN === 'false'">
            {{ measure.MEASURE_START | date }} - {{ measure.MEASURE_END | date }}
          </span>
        </td>
        <td class="text-center"
          [ngClass]="measure.STATUS_MEASURE === 'public' ? 'text-success' : measure.STATUS_MEASURE === 'private' ? 'lifedi-color' : 'text-warning'">
          {{ measure.STATUS_MEASURE }}</td>
        <td class="text-center">
          <mat-slide-toggle color="primary" [(ngModel)]="!measure.IS_VIEW" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, measure)">
          </mat-slide-toggle>
        </td>

        <td class="text-center">
          <a *ngIf="measure.LINK !== ''" (click)="openLink(measure.LINK, measure.IS_MULTI_INFORMANT)" target="_blank">
            <img src="assets/other/link.png" alt="" width="20px">
          </a>
          <img *ngIf="measure.LINK === ''" src="assets/other/link.png" alt="" width="20px" style="cursor: not-allowed;">
        </td>

        <td class="text-center">
          <a (click)="detail(measure)" style="cursor: pointer;">
            <img src="assets/other/file.png" style="width: 23px;">
          </a>
        </td>

        <td class="text-center">
          <a *ngIf="measure.STATUS_MEASURE !== 'draft'" (click)="exportDate(measure.MEASURE_ID, measure.MEASURE_NAME)"
            style="cursor: pointer;">
            <img src="assets/other/export.png" style="width: 23px;">
          </a>
          <a *ngIf="measure.STATUS_MEASURE === 'draft'" style="cursor: not-allowed;">
            <img src="assets/other/export.png" style="width: 23px;">
          </a>
        </td>
      </tr>
    </tbody>
  </nz-table>


  <!-- search -->
  <nz-table *ngIf="isSearch" #groupingTable [nzData]="searchMeasure" nzBordered nzSize="large"
    class="table table-striped">
    <thead>
      <tr>
        <th class="text-center" [nzSortFn]="sortIdFn">รหัสแบบทดสอบ</th>
        <th class="text-center">ชื่อแบบทดสอบ</th>
        <th class="text-center">วันเปิด - วันปิดแบบทดสอบ</th>
        <th class="text-center" [nzFilters]="filterStatus" [nzFilterFn]="statusFilterFn">สถานะ</th>
        <th class="text-center" [nzFilters]="filterViewStatus" [nzFilterFn]="viewStatusFilterFn">สถานะการมองเห็น</th>
        <th class="text-center">ลิงก์</th>
        <th class="text-center">รายละเอียด</th>
        <th class="text-center">Export</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let measure of groupingTable.data;">
        <td class="text-center">{{ measure.MEASURE_ID }}</td>
        <td class="text-center">{{ measure.MEASURE_NAME }}</td>
        <td class="text-center">
          <span *ngIf="measure.ALWAYS_OPEN === 'true'">
            เปิดตลอด
          </span>
          <span *ngIf="measure.ALWAYS_OPEN === 'false'">
            {{ measure.MEASURE_START | date }} - {{ measure.MEASURE_END | date }}
          </span>
        </td>
        <td class="text-center"
          [ngClass]="measure.STATUS_MEASURE === 'public' ? 'text-success' : measure.STATUS_MEASURE === 'private' ? 'lifedi-color' : 'text-warning'">
          {{ measure.STATUS_MEASURE }}
        </td>
        <td class="text-center">
          <mat-slide-toggle color="primary" [(ngModel)]="!measure.IS_VIEW" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, measure)">
          </mat-slide-toggle>
        </td>

        <td class="text-center">
          <a *ngIf="measure.LINK !== ''" (click)="openLink(measure.LINK, measure.IS_MULTI_INFORMANT)" target="_blank">
            <img src="assets/other/link.png" alt="" width="20px">
          </a>
          <img *ngIf="measure.LINK === ''" src="assets/other/link.png" alt="" width="20px" style="cursor: not-allowed;">
        </td>

        <td class="text-center">
          <a (click)="detail(measure)" style="cursor: pointer;">
            <img src="assets/other/file.png" style="width: 23px;">
          </a>
        </td>

        <td class="text-center">
          <a *ngIf="measure.STATUS_MEASURE !== 'draft'" (click)="exportDate(measure.MEASURE_ID, measure.MEASURE_NAME)"
            style="cursor: pointer;">
            <img src="assets/other/export.png" style="width: 23px;">
          </a>
          <a *ngIf="measure.STATUS_MEASURE === 'draft'" style="cursor: not-allowed;">
            <img src="assets/other/export.png" style="width: 23px;">
          </a>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
